import { get } from 'lodash';
import useOrganisation from './useOrganisation';
import useUserOrganisations from './useUserOrganisations';
import { Integrations, CSVIntegrationTypes } from '../util/constants';

function useOrganisationInfo() {
  const organisations = useUserOrganisations();
  const organisation = useOrganisation(null, {
    suspense: false,
    throwOnError: false,
  });

  const hasOrganisations = organisations && organisations.length > 0;
  const expiredToken = get(organisation, 'accessToken.expired', false);
  const isManualCSV =
    get(organisation, 'accountingSoftware', false) === Integrations.CSV &&
    get(organisation, 'accessToken.type', false) === CSVIntegrationTypes.MANUAL;
  const expiredTrial = get(organisation, 'subscription.isExpiredTrial', false);
  const isSuspended = get(organisation, 'subscription.isSuspended', false);
  const isInTrial = get(organisation, 'subscription.isInTrial', false);
  const planName =
    get(organisation, 'subscription.plan.title') ||
    get(organisation, 'subscription.plan.name') ||
    'no_plan';
  const noChase = get(organisation, 'noChase');
  const chasingStatus = noChase === true ? 'Paused' : 'Chasing';
  const connectionStatus = expiredToken === true ? 'Disconnected' : 'Connected';
  const signupDate = get(organisation, 'createdAt');
  const trialExpiryDate = get(organisation, 'subscription.trialExpiryDate');
  const trialExpired = isInTrial ? trialExpiryDate : undefined;
  const stripeFee = get(organisation, 'features.stripeFee') || 0.5;
  const isNylasConnected = get(organisation, 'users', []).find(user => user.nylas?.isConnected);

  return {
    ...organisation,
    hasOrganisations,
    expiredToken,
    expiredTrial,
    isSuspended,
    isInTrial,
    planName,
    noChase,
    chasingStatus,
    connectionStatus,
    signupDate,
    trialExpired,
    isManualCSV,
    stripeFee,
    isNylasConnected,
  };
}

export default useOrganisationInfo;
